"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var initFooterForm = function () {
    var forms = document.querySelectorAll('.footer__signup-form__form');
    if (forms.length === 0) {
        return;
    }
    var config = window.wpdevFooterForm;
    if (!config) {
        return;
    }
    forms.forEach(function (form) {
        var responseContainer = form.querySelector('.footer__signup-form__response');
        var submitButton = form.querySelector('button[type="submit"]');
        var renderMessage = function (message, type) {
            if (!responseContainer) {
                return;
            }
            responseContainer.innerHTML = '';
            responseContainer.classList.remove('is-success', 'is-error');
            responseContainer.classList.add("is-".concat(type));
            var span = document.createElement('span');
            span.className = "footer__signup-form__response-text is-".concat(type);
            span.textContent = message;
            responseContainer.appendChild(span);
            responseContainer.classList.add('submission-response');
            submitButton === null || submitButton === void 0 ? void 0 : submitButton.classList.add('submission-response');
        };
        var setSubmittingState = function (submitting) {
            if (!submitButton) {
                return;
            }
            submitButton.disabled = submitting;
            submitButton.setAttribute('aria-busy', submitting ? 'true' : 'false');
        };
        form.addEventListener('submit', function (event) { return __awaiter(void 0, void 0, void 0, function () {
            var formData, ajaxUrl, response, result, error_1;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        event.preventDefault();
                        if (responseContainer) {
                            responseContainer.innerHTML = '';
                            responseContainer.classList.remove('is-success', 'is-error');
                        }
                        setSubmittingState(true);
                        formData = new FormData(form);
                        ajaxUrl = config.ajaxUrl || form.action;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 4, 5, 6]);
                        return [4 /*yield*/, fetch(ajaxUrl, {
                                method: 'POST',
                                body: formData,
                                headers: {
                                    'X-Requested-With': 'XMLHttpRequest',
                                },
                            })];
                    case 2:
                        response = _c.sent();
                        return [4 /*yield*/, response.json()];
                    case 3:
                        result = _c.sent();
                        if (result === null || result === void 0 ? void 0 : result.success) {
                            renderMessage(((_a = result.data) === null || _a === void 0 ? void 0 : _a.message) || config.successMessage, 'success');
                            form.reset();
                        }
                        else {
                            renderMessage(((_b = result === null || result === void 0 ? void 0 : result.data) === null || _b === void 0 ? void 0 : _b.message) || config.errorMessage, 'error');
                        }
                        return [3 /*break*/, 6];
                    case 4:
                        error_1 = _c.sent();
                        renderMessage(config.errorMessage, 'error');
                        console.error('Footer form submission failed', error_1);
                        return [3 /*break*/, 6];
                    case 5:
                        setSubmittingState(false);
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        }); });
    });
};
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooterForm);
}
else {
    initFooterForm();
}
